import { ConfigurationAndRights } from '../ConfigurationAndRights';
import { ConfigurationRight } from '../ConfigurationRight';
import { ConfigurationPersistenceMapper } from './persistence/ConfigurationPersistenceMapper';

export class ConfigurationAndRightsMapper {
  static toDomain(dto: SimpleProjectServiceAPI.ConfigurationDataDto): ConfigurationAndRights {
    return {
      configuration: ConfigurationPersistenceMapper.toDomain(dto),
      rights: dto.isEditable ? [ConfigurationRight.WRITE] : [],
    };
  }
}
